<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Depositar efectivo
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Depositar efectivo</span>
    </p>
  </div>
</div>
<!-- Heading -->

<app-deposito-efectivo-cabecera (onSearch)="onSearch($event)">
</app-deposito-efectivo-cabecera>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">


    <div class="row" *ngIf="listaResumen?.length === 0">
      <div class="col">
        <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
          No existen registros para el filtro seleccionado</a>
      </div>
    </div>

    <!-- <ng-container *ngIf="listaResumen?.length > 0"> -->

    <app-deposito-efectivo-control-resumido [listaResumen]="listaResumen"
      [ngClass]="{'visible': listaResumen?.length > 0, 'invisible': listaResumen?.length === 0}"
      (onPageChange)="onPageChange($event)" [paginationContext]="paginationContext">
    </app-deposito-efectivo-control-resumido>

    <app-deposito-efectivo-declaracion [isVisible]="listaResumen !== null"
      [ngClass]="{'visible': listaResumen?.length > 0, 'invisible': listaResumen?.length === 0}">
    </app-deposito-efectivo-declaracion>

    <!-- </ng-container> -->

  </div>
</div>

<div *ngIf="listaResumen?.length > 0" class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" class="btn btn-sm" mdbBtn type="button" color="success" mdbWavesEffect (click)="Guardar()">
      Depositar efectivo
    </button>
  </div>
</div>